export const filterFormControlStyle = {
  display: { base: 'flex', lg: 'block' },
  flex: '1 1 100%',
  flexDirection: { base: 'row', lg: 'column' },
  alignItems: 'center',
  justifyContent: 'end',
};

export const filterSelectStyle = {
  ml: { base: '0.5rem', lg: 0 },
  flex: { base: '0 1 62%', lg: 'unset' },
};
